/**
 * @file paddle page impact
 * @author wanzhongyun
 */

import { useMemo, useState, useEffect, useRef } from 'react';
import { Badge } from 'antd';
import { IinterImpact, IimpactData } from './../../types';
import './style.less';

enum ARROW {
    LEFT = 1,
    RIGHT = 2
};

const Impact: React.FC<IinterImpact>= props => {

    const { title, desc, allLink, indexList, logoList } = props;
    const lableList = useMemo(() => ['Millions', 'K', 'K', 'K+'], []);
    const [dataList, setDataList] = useState<IimpactData[]>([]);
    const [logiIndex, setLogiIndex] = useState<number>(0);

    useEffect(() => {
        const currentList = indexList.map((item, index) => {
            return {...item, unit: lableList[index]}
        });
        setDataList(currentList);
    }, [indexList, lableList]);

    const partnerWrapperRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        // 计算一下partner-wrapper的宽度
        if (partnerWrapperRef.current && logoList.length) {
            partnerWrapperRef.current.style.width = `${logoList.length * 244 - 20}px`;
        }
    }, [logoList]);

    const handleLogoBtn = (arrow: ARROW) => {
        // 计算partner-wrapper位置
        const logoLength = logoList.length;
        const scrollLength = logoList.length - 5;

        if (arrow === ARROW.LEFT && partnerWrapperRef.current && logiIndex > 0 && logoLength) {
            partnerWrapperRef.current.style.left = `-${(logiIndex - 1) * 244}px`;
            setLogiIndex(logiIndex - 1);
        }

        else if (arrow === ARROW.RIGHT && partnerWrapperRef.current && scrollLength > logiIndex) {
            partnerWrapperRef.current.style.left = `-${(logiIndex + 1) * 244}px`;
            setLogiIndex(logiIndex + 1);
        }
    };

    return <div className='paddle-inter-impact' onMouseEnter={() => localStorage.setItem('powerStatus', 'outerBottom')}>
        <div className='paddle-inter-impact-title'>{ title }</div>
        <div className='paddle-inter-impact-desc'>{ desc }</div>
        <div className='paddle-inter-impact-back'>
            {
                [...Array(9)].map(() => <Badge status="processing" />)
            }
        </div>
        <div className='paddle-inter-impact-data'>
            {
                dataList.map(item => <div className='data-item' key={item.title + item.desc}>
                    <div className='data-item-value'>
                        <div className='data-item-value-title'>{ item.title }</div>
                        <div className='data-item-value-unit'>{ item.unit }</div>
                    </div>
                    <div className='data-item-desc'>{ item.desc }</div>
                </div>)
            }
        </div>
        <div className='paddle-inter-impact-partner'>
            <div className='partner-wrapper' ref={partnerWrapperRef}>
                {
                    logoList.map((item, index) => <div className='partner-item' key={item.imageUrl + item.link + index}>
                        <img className='partner-item-image' src={item.imageUrl} alt={item.imageUrl} />
                    </div>)
                }
            </div>
        </div>
        <div
            className='paddle-inter-impact-partner-left'
            onClick={() => handleLogoBtn(ARROW.LEFT)}
            style={{cursor: logiIndex ? 'pointer' : 'not-allowed'}}
        />
        <div
            className='paddle-inter-impact-partner-right'
            onClick={() => handleLogoBtn(ARROW.RIGHT)}
            style={{cursor: (logoList.length - 5) - logiIndex > 0 ? 'pointer' : 'not-allowed'}}
        />
        <div className='paddle-inter-impact-all-partner'>
            <a href={allLink} target='_blank' rel="noreferrer">
                Show All<span className='all-partner-arrow' />
            </a>
        </div>
    </div>
};

export default Impact;